import { render, staticRenderFns } from "./complaintManage.vue?vue&type=template&id=6fe6a2da&scoped=true&"
import script from "./complaintManage.vue?vue&type=script&lang=js&"
export * from "./complaintManage.vue?vue&type=script&lang=js&"
import style0 from "./complaintManage.vue?vue&type=style&index=0&id=6fe6a2da&lang=scss&scoped=true&"
import style1 from "./complaintManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe6a2da",
  null
  
)

export default component.exports